<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 50px;">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-left" style="height: 50px; line-height: 50px;">
<!--            <date-picker v-model="dateRange" valueType="format" @change="dateRangeSelected" range></date-picker>-->

            <input v-model="filter.requester" style="height: 34px; line-height: 34px; width: 200px;" placeholder="이름으로 검색" @change="searchList"/>
            <select v-model="filter.type" style="height: 34px; line-height: 34px;">
              <option value="all">All</option>
              <option value="pending">진행중</option>
              <option value="new">신규</option>
              <option value="completed">완료</option>
            </select>
<!--            <select v-model="stateFilter" style="height: 34px; line-height: 34px;">-->
<!--              <option v-for="state in stateList" :value="state.value">{{state.title}}</option>-->
<!--            </select>-->
            <button class="btn btn-success" @click="searchList">불러오기</button>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: calc(100% - 50px);">
      <div class="container-fluid h-100" style="overflow-y: scroll;">


        <div class="row">
          <div class="col-12">
            <table class="table text-left">
              <tr class="sticky-header">
<!--                <th>Ref</th>-->
                <th>신청자</th>
                <th style="width: 150px;">상태</th>
                <th>이사종류</th>
                <th class="hide-mobile" style="width: 150px;">접수일</th>



<!--                <th>상태</th>-->
<!--                <th>방문 요청 일시</th>-->

                <th class="hide-mobile">전화번호</th>
                <th class="hide-mobile" style="min-width: 200px;">메모</th>

                <th class="hide-mobile">From</th>
                <th class="hide-mobile">To</th>

              </tr>
              <tbody>
              <tr v-for="item in items" v-on:click="openItem(item.id)" v-bind:key="'item-request-row-' + item.id" v-bind:class="[{'dist-row': item.state >= 0 && item.state < 100},{'state-0': item.state === 0}, {'completed-request-row':item.state === 100}]">
<!--                <td v-on:click="openItem(item.id)"><span>{{item.reference}}</span></td>-->
                <td>
                  <div v-if="item.companyName !== null && item.companyName.length > 0"><strong>[{{item.companyName}}]</strong></div>
                  {{item.requester}}
                  <div v-if="item.state === 100">
                    <strong>완료</strong>
                  </div>
                </td>
                <td>
                  {{getStateString(item.state)}}
                </td>
                <td>{{item.shippingMode}}</td>
                <td class="hide-mobile">{{getDateString(item.createdTimestamp)}}</td>

<!--                <td class="hide-mobile">{{getMoveTypeString(item.requestType)}}</td>-->

<!--                <td>{{getStateString(item.state)}}</td>-->

<!--                <td>{{item.visitDate}} {{item.visitHour}}시</td>-->

                <td class="hide-mobile">{{item.phoneNumber}}<br/>{{item.email}}</td>
                <td class="hide-mobile">{{item.memo}}</td>

                <td class="hide-mobile">{{item.addressFrom}}</td>
                <td class="hide-mobile">{{item.countryTo}}<br>{{item.addressTo}}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div style="position: fixed; cursor: pointer; bottom: 20px; right: 20px; padding: 10px; background-color: #C4EACF; color:black; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px gray;"
         v-if="editItem === false" v-on:click="createNewItem">
      추가하기
    </div>
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="editItem != false">
      <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: calc(100% - 20px); transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">
        <request-item-view
          :item="editItem"
          :customers="customers"
          :on-updated="onItemUpdated"
          :on-close="onItemClosed"
          :on-deleted="onItemDeleted"
          :on-clone="cloneRequestItem"/>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    getRequest,
    getRequestsByState,
    getRequestsByTime,
    getRequestsByName,
    convertState,
    searchRequests,
    moveTypeString,
    getParkingValues,
    updateRequest,
    sendEmailToCustomer,
    getStateList,
    sendEmailLinkToCustomer,
    getRequestPDF,
    getStaff,
    getJobLinkers,
    createNewJob, deleteJobLinker, updateJobLinker, createNewRequest,
  } from "../api/request";
  import {millisToDate, millisToReadable, showDialog} from "../api/utils";
    import {getMetasByType, updateMetaItem} from "../api/meta";
  import {
    createNewGoodItem,
    deleteGood, getGoods,
    getGoodSizeList,
    getLocationList,
    getPreparationItemList,
    updateGood
  } from "../api/goods";
  import {getCustomers, getCustomer} from "../api/customers";
  import {getDocuments} from "../api/documents";
  import {} from "../api/item";
  import RequestItemView from "./RequestItemView";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

    export default {
        name: "MoveJobs",
        data() {
          return {
            items:[],
            filter: {
              dataFrom:'',
              dateTo:'',
              stateFrom:0,
              stateTo:100,
              requester:'',
              type:'pending',
            },

            stateList: getStateList(),
            adminItems:[],
            editItem:false,
            parkingValues:getParkingValues(),
            goodSizeList:getGoodSizeList(),
            preparationList:[],

            locationList:[],
            emailItem:false,
            documents:[],
            staffList:[],
            dateRange:null,
            stateFilter:0,
            customers:[],
          }
        },
      components: {
        RequestItemView,
        DatePicker
      },
      created() {
          // this.getList();
          this.getMetaList();
      },
      mounted() {
          this.getCustomerList();
          this.getPreparationItemList();
      },
      methods: {
          dummy: function() {

          },
          dateRangeSelected: function() {
            console.log("dateRangeSelected")
            console.log(this.$data.dateRange)

            if(this.$data.dateRange.length !== 2) {
              return;
            }

            if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
              let temp = this.$data.dateRange[1];
              this.$data.dateRange[0] = this.$data.dateRange[1];
              this.$data.dateRange[1] = temp;
            }

          },
        getCustomerList: function() {
          let self = this;
          getCustomers()
          .then(function(data){
            console.log("Customer list");
            console.log(data);
            if(data.success === true) {
              self.$data.customers = data.item;
            }
            self.searchList();
          })
          .catch(function(err) {

          })
        },
        searchList: function() {
          let self = this;
          let query = "";
          if(this.$data.filter.requester !== null && this.$data.filter.requester.length > 0)  {
            if(this.$data.filter.type === 'all') {
              query += 'stateFrom=-100&stateTo=100';
            } else if(this.$data.filter.type === 'pending') {
              query += 'stateFrom=0&stateTo=99';
            } else if(this.$data.filter.type === 'completed') {
              query += 'stateFrom=100&stateTo=100';
            } else if(this.$data.filter.type === 'new') {
              query += 'stateFrom=0&stateTo=0';
            }
            query += '&searchName=' + this.$data.filter.requester;
          } else {
            if(this.$data.filter.type === 'all') {
              showDialog("전체 검색을 위해서는 신청자 이름을 입력해주세요");
              return;
            } else if(this.$data.filter.type === 'pending') {
              query += 'stateFrom=0&stateTo=99';
            } else if(this.$data.filter.type === 'completed') {
              showDialog("완료된 검색을 위해서는 신청자 이름을 입력해주세요");
            } else if(this.$data.filter.type === 'new') {
              query += 'stateFrom=0&stateTo=0';
            }
          }

          searchRequests(query)
          .then(function(data) {
            if(data.success == true) {
              self.$data.items = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            let msg = err;
            if(err.response != undefined) {
              console.log(err.response);
              msg += ' (' + err.response  + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
          getList: function() {
            let self = this;
            getRequestsByState(this.$data.filter.stateFrom, this.$data.filter.stateTo)
            .then(function(data) {
              if(data.success == true) {
                self.$data.items = data.item;
              } else {
                window.alert(data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              let msg = err;
              if(err.response != undefined) {
                console.log(err.response);
                msg += ' (' + err.response  + ')';
              }
              showDialog(msg, "ERROR");o
            })
          },
          getMetaList: function() {
            let self = this;
            getMetasByType('move_admin_email')
            .then(function(data) {
              if(data.success) {
                self.$data.adminEmailItem = data.item;
              } else {

              }
            })
            .catch(function(err) {

            })
          },
          getStaffList: function() {
            let self = this;
            getStaff()
            .then(function(data) {
              if(data.success == true) {
                self.$data.staffList = data.item;
              } else {

              }
            })
            .catch(function(err) {

            })
          },
          isUserAssigned: function(user) {
            if(this.$data.editItem.assignees.length > 0) {
              for(let i = 0 ; i < this.$data.editItem.assignees.length ; i++) {
                if(this.$data.editItem.assignees.userId === user.id) {
                  return true;
                }
              }
            }
            return false;
          },
          assignStaff: function(user) {
            if(this.$data.editItem.assignees.length > 0) {
              for(let i = 0 ; i < this.$data.editItem.assignees.length ; i++) {
                if(this.$data.editItem.assignees.userId === user.id) {
                  showDialog("Already assigned");
                  return;
                }
              }
            }
            let newItem = createNewJob(this.$data.editItem.id, user);

            let self = this;
            updateJobLinker(newItem)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem.assignees.push(data.item);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
          },
          deleteAssignee: function(index) {
            if(this.$data.editItem.assignees[index].id == 0) {
              this.$data.editItem.assignees.splice(index, 1);
              return;
            }
            let self = this;
            deleteJobLinker(this.$data.editItem.assignees[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem.assignees.splice(index, 1);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
          },
          getPreparationItemList: function() {
            let self = this;
            getGoods('preparation_example')
            .then(function(data) {
              if(data.success == true) {
                self.$data.preparationList = data.item;
              }
            })
          },
          updateAdminEmail: function(index) {
            let self = this;
            updateMetaItem(this.$data.admainEmailItems[index])
            .then(function(data) {
              if(data.success) {
                self.$data.adminEmailItem = data.item;
              } else {
                window.alert("Failed to update email");
              }
            })
            .catch(function(err) {
              console.log(err);
            })
          },
          addNewAdminEmail: function() {
            let newAdminItem = {
              id:0,
              type:'move_admin_email',
              charVar3:'',
            }
            this.$data.adminEmailItems.push(newAdminItem);
          },
          getStateString: function(state) {
            for(let i = 0 ; i < this.$data.stateList.length ; i++) {
              if(this.$data.stateList[i].value == state) {
                return this.$data.stateList[i].title;
              }
            }
            return 'Unknown('+state +')';
          },
          getDateTime:millisToReadable,
          getDateString:millisToDate,
          getMoveTypeString: moveTypeString,
          openItem: function(id) {
            let self = this;
            getRequest(id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem = data.item;
                console.log(self.$data.editItem);
                self.sortGoods();
              }
            })
            .catch(function(err) {

            })
          },
          createNewItem: function() {
            this.$data.editItem = createNewRequest();
          },
          downloadPDF: function() {
            let self = this;
            const FileDownload = require('js-file-download');
            getRequestPDF(this.$data.editItem.id)
            .then(function(response) {
              FileDownload(response.data, "MOVE-JOB-" + self.$data.editItem.id + ".pdf");
            })
            .catch(function(err) {

            })
          },
          updateItem: function() {
            let self = this;
            updateRequest(this.$data.editItem)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.items.length ; i++) {
                  if(self.$data.items[i].id == data.item.id) {
                    self.$data.items.splice(i, 1, data.item);
                    break;
                  }
                }
                self.openItem(data.item.id);

              }
            })
            .catch(function(err){

            })
          },
        onItemDeleted: function(item) {
          for(let i = 0 ; i < this.$data.items.length ; i++) {
            if(this.$data.items[i].id == item.id) {
              this.$data.items.splice(i, 1);
              break;
            }
          }
          this.$data.editItem = false;
        },
        onItemUpdated: function(item) {
          let found = false;
          for(let i = 0 ; i < this.$data.items.length ; i++) {
            if(this.$data.items[i].id === item.id) {
              if(item.state === 100 && this.$data.filter.type === 'pending') {
                this.$data.items.splice(i, 1);
              } else {
                this.$data.items.splice(i, 1, item);
                found = true;
              }

              break;
            }
          }
          if(found === false) {
            this.$data.items.push(item);
          }
          // this.$data.editItem = false;
        },
        onItemClosed: function() {
            this.$data.editItem = false;
        },
          sortGoods: function() {
            if(this.$data.locationList == null || this.$data.locationList.length == 0) {
              return;
            }

            console.log("Location List");
            console.log(this.$data.locationList);
            let self = this;
            this.$data.editItem.items.sort(function(a, b) {
              let aPos = 0;
              let bPos = 0;
              for(let i = 0 ; i < self.$data.locationList.length ; i++) {
                if(self.$data.locationList[i].title === a.location) {
                  aPos = self.$data.locationList[i].pos;
                  break;
                }
              }
              for(let i = 0 ; i < self.$data.locationList.length ; i++) {
                if(self.$data.locationList[i].title === b.location) {
                  bPos = self.$data.locationList[i].pos;
                  break;
                }
              }

              // console.log(a.title + " " + a.location + " pos " + aPos + " " + b.title + " " + b.location + " pos " + bPos);
              if(aPos < bPos) {
                return -1;
              } else if(aPos > bPos) {
                return 1;
              }
              return 0;

            })
          },
          addGoodItem: function() {
            let newGoodItem = createNewGoodItem(this.$data.editItem.id, 'item');
            newGoodItem.requestId = this.$data.editItem.id;
            this.$data.editItem.items.push(newGoodItem);
          },
          updateGoodItem: function(index) {

            let item = this.$data.editItem.items[index];
            if(item.title == null || item.title.length == 0) {
              return;
            }
            let self = this;
            console.log("update good item");
            updateGood(item)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.$data.editItem.items.splice(index, 1, data.item);
                self.sortGoods();
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
          },
          deleteGoodItem: function(index) {
            if(this.$data.editItem.items[index].id == 0) {
              this.$data.editItem.items.splice(index, 1);
              return;
            }

            let self = this;
            deleteGood(this.$data.editItem.items[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem.items.splice(index, 1);
              }
            })
            .catch(function(err) {

            })
          },
        addPreparationItem: function() {
          let newGoodItem = createNewGoodItem(this.$data.editItem.id, 'preparation');
          newGoodItem.requestId = this.$data.editItem.id;
          this.$data.editItem.preparations.push(newGoodItem);
        },
        updatePreparationItem: function(index) {

          let item = this.$data.editItem.preparations[index];
          if(item.title == null || item.title.length == 0) {
            return;
          }
          let self = this;
          console.log("update good item");
          updateGood(item)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.$data.editItem.preparations.splice(index, 1, data.item);
              }
            })
            .catch(function(err) {

            })
        },
        deletePreparationItem: function(index) {
          if(this.$data.editItem.preparations[index].id == 0) {
            this.$data.editItem.preparations.splice(index, 1);
            return;
          }

          let self = this;
          deleteGood(this.$data.editItem.items[index].id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem.preparations.splice(index, 1);
              }
            })
            .catch(function(err) {

            })
        },
        onClickPreparationList: function(item) {
          let newGoodItem = createNewGoodItem(this.$data.editItem.id, 'preparation');
          newGoodItem.requestId = this.$data.editItem.id;
          newGoodItem.title = item.title;
          let self = this;
          updateGood(newGoodItem)
            .then(function(data) {
              console.log(data);
              if(data.success == true) {
                self.$data.editItem.preparations.push(data.item);
              }
            })
            .catch(function(err) {

            })
        },
        showPreparationItem: function(item) {
            for(let i = 0 ; i < this.$data.editItem.preparations.length ; i++) {
              if(this.$data.editItem.preparations[i].title == item.title) {
                return false;
              }
            }
            return true;
        },
        removeEmailDocItem: function(index) {
            this.$data.emailItem.documents.splice(index, 1);
        },
        addEmailDocItem: function(doc) {
          this.$data.emailItem.documents.push(JSON.parse(JSON.stringify(doc)));
        },
        sendEmailForm: function() {
            sendEmailLinkToCustomer(this.$data.editItem.id)
          .then(function(data) {
            if(data.success == true) {
              showDialog("Sent");
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg);
          })
        },
        openEmailItem: function() {
          let item = {
            requestId:this.$data.editItem.id,
            email:this.$data.editItem.email,
            subject:'UKO Trade 이사 #' + this.$data.editItem.reference,
            body:'안녕하세요 UKO Trade입니다\n',
            documents:[],
          }
          this.$data.emailItem = item;
          let self = this;
          getDocuments(0, 'info_document')
          .then(function(data) {
            if(data.success == true) {
              self.$data.documents = data.item;
            }
          })
          .catch(function(err) {

          })

        },
        sendEmailToCustomer: function() {
          let self = this;
          sendEmailToCustomer(this.$data.emailItem)
          .then(function(data) {
            self.$data.emailItem = false;
            showDialog(data.message);
          })
          .catch(function(err) {

          })
        },
        getLocationList: function() {
          let self = this;
          getGoods('location', 0, 'pos')
          .then(function(data) {
            if(data.success == true) {
              self.$data.locationList = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg);
          })
        },
        cloneRequestItem: function(item) {
          this.$data.editItem = false;
          let newItem = createNewRequest();
          newItem.id = 0;
          newItem.countryFrom=item.countryTo;
          newItem.countryTo=item.countryFrom;
          newItem.requestMethod = item.requestMethod;
          newItem.companyName = item.companyName;
          newItem.phoneNumber = item.phoneNumber;
          newItem.customerId = item.customerId;
          newItem.addressFrom = item.addressTo;
          newItem.addressTo = item.addressFrom;

          if(item.shippingMode === 'SEA OUT') {
            newItem.shippingMode = 'SEA IN';
          } else if(item.shippingMode === 'SEA IN') {
            newItem.shippingMode = 'SEA OUT';
          } else if(item.shippingMode === 'AIR OUT') {
            newItem.shippingMode = 'AIR IN';
          } else if(item.shippingMode === 'AIR IN') {
            newItem.shippingMode = 'AIR OUT';
          } else if(item.shippingMode === 'EURO LAND') {
            newItem.shippingMode = 'EURO LAND';
          } else if(item.shippingMode === 'DOMESTIC') {
            newItem.shippingMode = 'DOMESTIC';
          }
          newItem.requester = item.requester;
          newItem.email = item.email;

          let self = this;
          console.log("clone now");
          updateRequest(newItem)
            .then(function(data) {
              if(data.success === true) {
                console.log("cloned");
                console.log(data.item);
                self.$data.items.push(data.item);
                self.openItem(data.item.id);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })

        }
      }
    }
</script>

<style scoped>
.state-0 {
  background: #FF9F9F;
}
</style>



// WEBPACK FOOTER //
// src/components/MoveJobs.vue